import { createApp } from "vue";
import { createPinia } from "pinia";
import PrimeVue from "primevue/config";
import hero from "./Hero.vue";
// import router from "./router";

import TJButton from "@components/TJButton.vue";

// Get the mounting element
const mountElement = document.getElementById("hero");
const spinnerElement = document.getElementById("hero-spinner");
// Access the attribute conditionally and create the Vue app instance
const style = mountElement ? mountElement.getAttribute("data-style") : null;
const app = createApp(hero, { style });

app.component("TJButton", TJButton);
app.component("Btn", TJButton);

app.use(createPinia());
// app.use(router);
app.use(PrimeVue);

// Mount the app and hide spinner once mounted
app.mount("#hero");
